<section class="rich-notes-wrapper">
  <p-editor placeholder="{{'Enter your note' | stringTranslate}}" [(ngModel)]="payload.notes" class="editor">
    <p-header>
       <span class="ql-formats">
         <button class="ql-bold" aria-label="Bold"></button>
         <button class="ql-italic" aria-label="Italic"></button>
         <button class="ql-underline" aria-label="Underline"></button>
         <select class="ql-size">
          </select>
          <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
          <button class="ql-list" value="bullet" aria-label="Unordered  List"></button>
         <select class="ql-align">
          </select>
        </span>
    </p-header>
  </p-editor>
</section>
